import { Button, Drawer, Space } from "antd";
import moment from "moment";
import { AiOutlineClose } from "react-icons/ai";
import DateLine from "../../../components/shared/DateLine";
import formatMoney from "../../../utils/formatMoney";

export default function RevenueServicesPannel({
  isVisible,
  setShowServices,
  services,
  startDate,
  endDate,
}: any) {

  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">Service's Revenue :</span>
          <DateLine startDate={startDate} endDate={endDate} />
        </div>
      }
      placement={"right"}
      width={800}
      onClose={() => setShowServices(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setShowServices(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="font-toyota">
        <div className="flex py-1 border-b border-gray-300">
          <div className="mr-2 w-10 text-center font-bold">S/N.</div>
          <div className="flex justify-between items-center flex-1">
            <div className="flex items-center">
              <div className="w-36 font-bold">Date</div>
              <div className="w-48 truncate text-left font-bold">
                Description
              </div>
              <div className="w-48 truncate font-bold">Customer</div>
              <div className="w-16 truncate ml-4 font-bold">Hrs Sold</div>
            </div>
            <div className="font-bold">Amount</div>
          </div>
        </div>
        {services?.data?.map((item: any, index: number) => (
          <div className="flex py-1 border-b border-gray-300" key={index}>
            <div className="mr-2 w-10 text-center">{index + 1}.</div>
            <div className="flex justify-between items-center flex-1">
              <div className="flex items-center">
                <div className="w-36">
                  {moment(item?.service_date.toString()).format("Do MMM YYYY")}
                </div>
                <div className="w-48 truncate text-left">
                  {item?.service_description}
                </div>
                <div className="w-48 truncate">
                  {item.customer === " " ? "-" : item.customer}
                </div>
                <div className="w-16 truncate ml-4">{item?.hours_sold}</div>
              </div>
              <div className="">{formatMoney(item?.sales_value)}</div>
            </div>
          </div>
        ))}
        <div className="flex justify-between items-start border-t-2 border-b-2 py-2">
          <div className=""></div>
          <div className="font-bold">{formatMoney(services?.service?.net)}</div>
        </div>
      </div>
    </Drawer>
  );
}
